import { useEffect, useState } from "react";
import { getDashboard } from "../controllers/dashboard";
import { useAuth } from "../components/auth/AuthProvider";
import { Card, Col, Container, Row } from "react-bootstrap";
import AdminDashboard from "../components/dashboard/AdminDashboard";
import MemberDashboard from "../components/dashboard/MemberDashboard";
import Nacional from "./app/Nacional";
import Region from "./app/Region";
import { useNavigate } from "react-router-dom";
import Loading from "../components/loading/Loading";
import TeamCoordinatorDashboard from "../components/dashboard/TeamCoordinatorDashboard";

function Dashboard() {
  const { token } = useAuth();
  const [data, setData] = useState()
  const [cards, setCards] = useState([])
  const [role, setRole] = useState();
  const [title, setTitle] = useState('Dashboard');
  const navigate = useNavigate();
  useEffect(() => {
    document.title = 'FAMA - Dashboard';
    loadDashboard();
  }, []);
  async function loadDashboard() {
    try {
      let d = await getDashboard(token);
      console.log('cards', d);
      setCards(d.cards);
      if (d.title) {
        setTitle(d.title);
      }
      if (d.type === 'admin') {
        setRole('admin');
      }
      else if (d.type === 'member') {
        setRole('member');
      }
      else if (d.type === 'presidente-comunidad') {
        setRole('admin');
      }
      else if (d.type === 'team-coordinator') {
        setRole('team-coordinator');
      }
      setData(d);
    }
    catch (e) {
      console.log(e);
      setRole('member');
    }
  }

  if (!data) {
    return <Loading text="Cargando"></Loading>
  }
  else if (role === 'admin') {
    console.log('data', data);
    switch(data.level) {
      case 1: navigate(`/app/org/nacional`); break;
      case 2: navigate(`/app/org/regiones/${data.org.region_id}`); break;
      case 3: navigate(`/app/org/diocesis/${data.org.diocesis_id}`); break;
      case 4: navigate(`/app/org/comunidades/${data.org.comunidad_id}`); break;
      default: break;
    }
  }
  else if (role === 'admin' && cards.length) {
    return <AdminDashboard data={cards} title={title} />;
  }
  else if (role === 'member') {
    return <MemberDashboard data={cards} />;
  }
  else if (role === 'team-coordinator') {
    return <TeamCoordinatorDashboard cards={cards} data={data.fullData}  />;
  }
}

export default Dashboard;
